import { render, staticRenderFns } from "./ElementTheme.vue?vue&type=template&id=332c1ced&scoped=true"
import script from "./ElementTheme.vue?vue&type=script&lang=js"
export * from "./ElementTheme.vue?vue&type=script&lang=js"
import style0 from "./ElementTheme.vue?vue&type=style&index=0&id=332c1ced&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c1ced",
  null
  
)

export default component.exports